import { render, staticRenderFns } from "./HighwayInput2.vue?vue&type=template&id=34b881e3"
import script from "./HighwayInput2.vue?vue&type=script&lang=js"
export * from "./HighwayInput2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports